import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

/**
 * X（Twitter）OAuth 認証URLを取得
 */
export async function getTwitterAuthLink(callbackUrl: string): Promise<{
  authUrl: string;
  oauthTokenSecret: string;
}> {
  const fn = httpsCallable<{ callbackUrl: string }, { authUrl: string; oauthTokenSecret: string }>(
    functions,
    'getTwitterAuthLink'
  );
  const result = await fn({ callbackUrl });
  return result.data;
}

/**
 * X（Twitter）OAuth トークンを保存
 */
export async function saveTwitterAuth(params: {
  oauthToken: string;
  oauthVerifier: string;
  oauthTokenSecret: string;
}): Promise<void> {
  const fn = httpsCallable<typeof params, { success: boolean }>(functions, 'saveTwitterAuth');
  await fn(params);
}

/**
 * NFT完走証をXに投稿
 */
export async function tweetWithMedia(params: { claimId: string; tweet: string }): Promise<{
  screenName: string;
  tweetId: string;
}> {
  const fn = httpsCallable<typeof params, { success: boolean; screenName: string; tweetId: string }>(
    functions,
    'tweetWithMedia'
  );
  const result = await fn(params);
  return {
    screenName: result.data.screenName,
    tweetId: result.data.tweetId,
  };
}
